import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { useSelector } from 'react-redux';
import { isKnownContact } from '../../contacts/operators/isKnownContact';
import { useContact } from '../../crm-integration/hooks/useContact';
import { useConversationIdByThreadId } from '../../crm-integration/hooks/useConversationIdByThreadId';
import { useCurrentView } from '../../custom-views/hooks/useCurrentView';
import ThreadView from '../../thread-view/components/ThreadView';
import { useFetchAssociatedTickets } from 'conversations-inbox-lib/tickets/fetch/useFetchAssociatedTicket';
import { jsx as _jsx } from "react/jsx-runtime";
const InboxThreadView = ({
  threadId,
  isContextualSidebarOpen,
  openZorseTaxonomyPanel
}) => {
  const {
    conversationId
  } = useConversationIdByThreadId({
    threadId
  });
  const {
    associatedTicket,
    error: associatedTicketError,
    loading: associatedTicketIsLoading
  } = useFetchAssociatedTickets({
    conversationId
  });
  const inboxId = useSelector(getCurrentInboxId);
  const view = useCurrentView();
  const {
    asyncContact
  } = useContact({
    threadId
  });
  const isKnownVisitor = isKnownContact(getData(asyncContact));
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    errorBoundaryName: "ThreadView",
    errorLoggingTitle: "Inbox ThreadView",
    children: /*#__PURE__*/_jsx(ThreadView, {
      threadId: threadId,
      isContextualSidebarOpen: isContextualSidebarOpen,
      openZorseTaxonomyPanel: openZorseTaxonomyPanel,
      isKnownVisitor: isKnownVisitor,
      view: view,
      ticket: associatedTicket,
      ticketIsLoading: associatedTicketIsLoading,
      ticketError: associatedTicketError,
      inboxId: inboxId
    })
  }, "threadView");
};
InboxThreadView.displayName = 'InboxThreadView';
export default InboxThreadView;